import { ActionCreator } from 'store/redux/ActionCreators';
import { StoreCrops } from '../types';
import { HarvestYield } from '../types/HarvestYield';

export enum CropAction {
  ReceiveCropList = 'RECEIVE_CROP_LIST',
  ReceiveCustomCropNominalWeights = 'RECEIVE_CUSTOM_CROP_NOMINAL_WEIGHTS',
}

export interface ReceiveCropListAction {
  type: CropAction.ReceiveCropList;
  cropList: StoreCrops;
}

export function receiveCropList(cropList: StoreCrops): ReceiveCropListAction {
  return {
    type: CropAction.ReceiveCropList,
    cropList,
  };
}

export interface ReceiveCustomCropNominalWeights {
  type: CropAction.ReceiveCustomCropNominalWeights;
  harvestMetadata: HarvestYield[];
}

export function receiveCustomCropNominalWeights(harvestMetadata: HarvestYield[]): ReceiveCustomCropNominalWeights {
  return {
    type: CropAction.ReceiveCustomCropNominalWeights,
    harvestMetadata,
  };
}

export type CropActions = ReceiveCropListAction | ReceiveCustomCropNominalWeights;

export interface CropActionsCreators {
  receiveCropList: ActionCreator<
    { cropList: StoreCrops },
    ReceiveCropListAction
  >;

  receiveCustomCropNominalWeights: ActionCreator<
    { harvestMetadata: HarvestYield[] },
    ReceiveCustomCropNominalWeights
  >;
}
